var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M2 12.2001H18V13.4001H2V12.2001ZM2 6.6001H18V7.8001H2V6.6001Z","fill":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }